import React from "react";
import SectionShell from "./SectionShell";

export default function ClosingInvitation() {
  return (
    <SectionShell
      id="meghivas"
      testId="closing-invitation"
      eyebrow="Záró meghívás"
      titleStart="Talán nem véletlen, hogy most"
      titleAccent="itt vagy"
      tinted
    >
      <p>
        Lehet, hogy nem minden kérdésedre kaptál választ. De talán megszületett benned egy új
        kérdés vagy felismerés. Esetleg egyszerűen csak egy érzés, hogy érdemes tovább menni
        ezen az úton. Az életünk során számtalan találkozás, kapcsolat és helyzet formál
        bennünket. Némelyik könnyedséget hoz. Mások próbára tesznek. Azonban mindegyik hordoz
        valamit, ami közelebb vihet önmagunkhoz. Talán most is egy ilyen pillanatban vagy. Egy
        olyan ponton, ahol valami már nem ugyanaz, mint korábban. Lehet, hogy még nem látod
        pontosan a következő lépést, valami már elindult benned.
      </p>

      {/* Extended personal invitation — a letter-like section */}
      <p>
        Előfordulhat, hogy már hosszú ideje keresed a választ. Könyvekben, előadásokban,
        képzéseken, vagy egyszerűen csak próbálod egyedül megérteni azt, ami újra és újra
        visszatér az életedben. Mégis ott van benned az érzés, hogy valami mélyebb összefüggés
        vár arra, hogy végre meglásd. Nem azért, mert kevés lennél, hanem mert vannak
        felismerések, amelyekhez néha szükségünk van egy másik ember jelenlétére. Egy olyan
        térre, ahol nem kell megfelelni, erősnek mutatkozni, vagy bizonyítani. Elég őszintén
        jelen lenni.
      </p>

      <h3
        data-testid="closing-invitation-consultation-highlight"
        className="font-serif-display text-[26px] sm:text-[30px] md:text-[34px] leading-[1.25] text-graphite text-center max-w-xl mx-auto my-12 md:my-14"
      >
        A konzultáció nem arról szól,
        <br />
        hogy én megmondom a{" "}
        <em className="text-gold" style={{ fontStyle: "italic" }}>
          választ
        </em>
        .
      </h3>

      <p>
        Bár mindenképp hozok be új információkat és összefüggéseket számodra. Azonban hiszem,
        hogy minden emberben ott vannak a saját válaszai, melyeket elég egy magasabb
        nézőpontból megvilágítani. Sokszor azonban a félelmek, a régi történetek, a berögzült
        minták vagy a megszokott nézőpontok elfedik őket. A közös munka során nem kész
        megoldásokat kapsz. Sokkal inkább felismeréseket és egy lehetőséget arra, hogy más
        szemmel nézz rá önmagadra, a kapcsolataidra és az életedre. Amikor ez megtörténik,
        gyakran nem a világ változik meg, hanem az, ahogyan jelen vagy benne.
      </p>

      <h3
        data-testid="closing-invitation-not-alone-highlight"
        className="font-serif-display text-[26px] sm:text-[30px] md:text-[34px] leading-[1.25] text-graphite text-center max-w-xl mx-auto my-12 md:my-14"
      >
        Nem kell mindent egyedül{" "}
        <em className="text-gold" style={{ fontStyle: "italic" }}>
          végigjárnod
        </em>
        .
      </h3>

      <p>
        Nem tudom helyetted megtenni az utat, de szívesen elkísérlek azon a szakaszon,
        ahol jól jön egy <span className="text-gold">tiszta tükör</span>, egy őszinte
        beszélgetés és egy olyan tér, ahol valóban meghallhatod önmagadat.
      </p>

      <h3
        data-testid="closing-invitation-time-highlight"
        className="font-serif-display text-[26px] sm:text-[30px] md:text-[34px] leading-[1.25] text-graphite text-center max-w-xl mx-auto my-12 md:my-14"
      >
        Ha úgy érzed, elérkezett az{" "}
        <em className="text-gold" style={{ fontStyle: "italic" }}>
          idő
        </em>
        …
      </h3>

      <p>
        …és ez a néhány sor megszólított benned valamit, talán nem véletlenül érkeztél
        ide. Lehet, hogy éppen most jött el az ideje annak az első lépésnek, amelyet már
        régóta halogatsz.
      </p>
      <p>
        Ha szeretnél más szemmel ránézni önmagadra, a kapcsolataidra vagy az életedben
        újra és újra visszatérő mintákra, ha megszületett benned a döntés,{" "}
        <em className="text-gold" style={{ fontStyle: "italic" }}>
          szeretettel várlak
        </em>{" "}
        egyéni konzultációra.
      </p>

      {/* Final stop — the doorway returns, clean */}
      <div className="my-8 md:my-10 text-center">
        <p className="font-serif-display italic text-[24px] sm:text-[28px] md:text-[32px] leading-[1.4] text-graphite max-w-xl mx-auto">
          A kapcsolat a kapu.
          <br />
          Az ajándék pedig a{" "}
          <span className="text-gold">felismerés</span>.
        </p>
        <p className="font-serif-display italic text-[24px] sm:text-[28px] md:text-[32px] leading-[1.35] text-graphite max-w-xl mx-auto mt-8 md:mt-10">
          A kérdés már csak az:
          <br />
          <span className="text-gold">Készen állsz-e</span> belépni rajta?
        </p>
      </div>

      <p className="text-center font-serif-display italic text-graphite text-[24px] sm:text-[28px] md:text-[32px] leading-[1.35] max-w-xl mx-auto">
        Ha igen, szeretettel hívlak erre a közös utazásra.
      </p>
    </SectionShell>
  );
}
